import React from "react";
import { Select as UI5Select, Option } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function Select({
  className,
  options,
  value,
  disabled = false,
  required = false,
  onChange,
  children,
  ...props
}) {
  return (
    <UI5Select
      disabled={disabled}
      required={required}
      onChange={onChange}
      className={cn(
        "w-full", // Full width by default
        className
      )}
      {...props}
    >
      {options
        ? options.map((option) => (
            <Option
              key={option.value}
              value={option.value}
              selected={option.value === value} // Mark selected option
            >
              {option.label}
            </Option>
          ))
        : children}
    </UI5Select>
  );
}

// Export Option for advanced usage
Select.Option = Option;
